// 台灣電話：0 開頭 + 8~9 碼數字，涵蓋手機（09 + 8 碼）與各縣市市話（含高雄 07 + 7 碼）
export const isValidTaiwanPhone = phone =>
	/^0\d{8,9}$/.test((phone ?? '').trim())
